import { useInfrastructureSectionContent } from './useInfrastructureSectionContent';
import { parseInfrastructureBankOnContent } from '../utils/infrastructureContent';

export const useInfrastructureBankOnContent = () =>
  useInfrastructureSectionContent(parseInfrastructureBankOnContent);
